import { Cancel } from 'axios'

export default {
  install: function (Vue) {
    /**
     * @param {Error} error
     */
    Vue.prototype.$httpError = {
      handle (error) {
        if (error instanceof Cancel) {
          console.error(`Cancelled HTTP request ${error.message}`)
        } else {
          this.$error(this.translate('unexpectedError'), 5000)
        }

        console.error(error)
      }
    }

    /**
     * @param {string[]} errors
     */
    Vue.prototype.$errorsToString = function (errors) {
      return 'Bad Request: ' + errors.join(';')
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/plugins/helpers.js